import { BoundedImage } from '@/components/BoundedImage';
import clsx from "clsx";

type AvatarProps = {
  /** Display name; the first letters of up to two words become the initials. */
  name?: string | null;
  /** Fallback when no name is available (e.g. an email address). */
  fallback?: string | null;
  /** Renderable image URL; when present it replaces the initials. */
  src?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
};

export const getInitials = (name?: string | null, fallback?: string | null) => {
  const source = (name ?? "").trim() || (fallback ?? "").trim();
  if (!source) return "?";
  const words = source.split(/\s+/).filter(Boolean);
  if (words.length >= 2) return `${words[0][0]}${words[1][0]}`.toUpperCase();
  return source.slice(0, 2).toUpperCase();
};

/** Initials in a teal circle with gold serif letters. No stock photos. */
const Avatar = ({ name, fallback, src, size = "md", className }: AvatarProps) => {
  const label = (name ?? "").trim() || (fallback ?? "").trim() || "User";
  return (
    <span
      className={clsx("pz-avatar", size === "lg" && "pz-avatar--lg", size === "sm" && "pz-avatar--sm", className)}
      role="img"
      aria-label={label}
    >
      {src ? <BoundedImage src={src} alt="" /> : getInitials(name, fallback)}
    </span>
  );
};

export default Avatar;
